import { Linking } from "react-native";

import type { AlertDialog } from "../../provider/alerts";

export const defaultOptions = { ios: { sound: true, badge: true } };

export const linkToSettings = (redirect?: () => void) => {
  void (async () => {
    try {
      await Linking.openSettings();
    } finally {
      if (redirect) {
        redirect();
      }
    }
  })();
};

export const pushNotificationsDeniedAlert = (
  redirect?: () => void,
): AlertDialog => {
  const alert: AlertDialog = {
    title: "Enable Notifications in Settings",
    message:
      "We're unable to enable notifications. Please enable them in your device settings.",
    acceptText: "Settings",
    cancellable: true,
    onAccept: () => {
      linkToSettings(redirect);
    },
  };
  return alert;
};

export const pushNotificationsErrorAlert = (
  redirect?: () => void,
): AlertDialog => {
  const alert: AlertDialog = {
    title: "We experienced an error",
    message:
      "Please navigate to your phone settings and adjust notifications for the app.",
    acceptText: "Settings",
    cancellable: true,
    onAccept: () => {
      linkToSettings(redirect);
    },
  };
  return alert;
};

export const pushNotificationsDisableAlert = (
  redirect?: () => void,
): AlertDialog => {
  const alert: AlertDialog = {
    title: "Disable Notifications in Settings",
    message: "Please disable notifications in your device settings.",
    acceptText: "Settings",
    cancellable: true,
    onAccept: () => {
      linkToSettings(redirect);
    },
  };
  return alert;
};
